import React, { useState } from "react";
import styled from "styled-components";

interface Props {
  file: File;
}

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  overflow: hidden;
`;

const PdfFrame = styled.iframe`
  flex: 1;
  width: 100%;
  border: none;
`;

export const PdfViewer: React.VFC<Props> = ({ file }) => {
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  React.useEffect(() => {
    const url = URL.createObjectURL(file);
    setFileUrl(url);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  if (!fileUrl) return null;

  return (
    <Container>
      <PdfFrame src={`${fileUrl}#navpanes=0`} title="PDF Preview" />
    </Container>
  );
};
